export default {
  userDetails: {
    firstName: "",
    lastName: "",
    mobileNo: "",
    mobileNoCountryCode: "",
    emailAddress: "",
    orgName: "",
    orgCode: "",
    countryCode: "",
    templateDbName: null,
  },
  hrappUserUId: 0,
  frequency: "",
  authenticationMethod: "",
  dashboardType: "EMPLOYEEMONITORINGDASHBOARD",
  password: "",
  otp: null,
};
